export default __webpack_public_path__ + "static/media/the_Product-three.546909e3.png";